var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_has.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_has.js
// module chunks = 6